<template>
  <div class="w-full h-full">
    <div class="flex items-center mt-5px">
      <el-select
        popper-class="visualization-select-popper"
        placeholder="专业"
        class="mr-5px"
        v-model="search.specialized"
        @change="changeList"
        clearable
      >
        <el-option
          v-for="(item, index) in specializedOption"
          :key="'type' + index"
          :label="item.teamName"
          :value="item.team"
        ></el-option>
      </el-select>
      <el-select
        popper-class="visualization-select-popper"
        placeholder="巡检路线"
        v-model="search.route"
        @change="changeList"
        clearable
      >
        <el-option
          v-for="(item, index) in routeOption"
          :key="'level' + index"
          :label="item.routeName"
          :value="item.route"
        ></el-option>
      </el-select>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 90px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column :label="`${$t('巡检站点')}`" show-overflow-tooltip prop="siteDesc">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15px cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="getTableList()"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import { PatrolApi } from '@wiz-api/huizhou2'
import { transferSkipCount } from '@/assets/js/TransferPage'

const patrolApi = new PatrolApi()
export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {},
  data() {
    return {
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      specializedOption: [],
      routeOption: [],
      search: {
        route: '',
        specialized: '',
      },
    }
  },
  methods: {
    async getTableList(isAll = false) {
      const params = {
        team: this.search.specialized, // 专业
        route: this.search.route, // 巡检路线编码
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      }
      if (isAll) {
        params.skipCount = 0
        params.maxResultCount = 999
      }
      const [err, res] = await patrolApi.getPatrolPointPage(params)
      if (!err) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    changeList() {
      this.getTableList()
    },
    // 绘制图标
    async drawMarker(deviceDetail, type) {
      await this.cloudRender.Marker?.destroyAllMarker()
      const backgroundUrl = `data://../apps/markers/inspectionAPicture/${type}.png`
      const pictureOption = {
        id: deviceDetail.id,
        pos: JSON.parse(deviceDetail.position),
        backgroundUrl,
        visible: true,
        nodeOffset: [0, 0],
        imgSize: [41, 59],
        markPosType: 1,
      }
      await this.cloudRender.Marker.createByPicture(pictureOption)
    },
    lookDetail(row) {
      if (row.position) {
        this.drawMarker(row, 'point-inspection-normal')
        this.moveToTag(row.perspective)
      }
    },
    // 移动至标签
    async moveToTag(strPosition) {
      if (!strPosition) return
      const perspective = JSON.parse(strPosition)
      const cameraParams = {
        eye: perspective[0].split(',').map((it) => {
          return Number(it)
        }),
        target: perspective[1].split(',').map((it) => {
          return Number(it)
        }),
        up: perspective[2].split(',').map((it) => {
          return Number(it)
        }),
      }
      await this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
    },
    // 获取专业
    async getSpecializedOption() {
      const [err, res] = await patrolApi.getPatrolTeamList()
      if (!err) {
        this.specializedOption = res
      }
    },
    // 获取线路
    async getRouteOption() {
      const [err, res] = await patrolApi.getPatrolRouteList()
      if (!err) {
        this.routeOption = res
      }
    },
  },
  mounted() {},
  created() {
    this.getSpecializedOption()
    this.getRouteOption()
    this.getTableList()
  },
  async beforeDestroy() {
    await this.cloudRender.Marker?.destroyAllMarker()
  },
}
</script>

<style>
</style>
